import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './ListingTile.module.css';
import { PromoButton } from '../promo-button/PromoButton';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';
import PromoIllustration from '../widgets/Illustration/PromoIllustration';

export const ListingTile = (props) => {
    const isLink = !!props.linkText;
    const Tag = isLink ? 'a' : 'div';
    const hasText = props.title || props.subtitle;

    const containerClassName = clsx(styles.container, (isLink || props.onClick) && styles.containerClickable);

    const imgContainerClassName = clsx(styles.imgContainer, hasText && styles.imgContainerWithText);

    const anchorProps = isLink ? { href: props.linkUrl } : {};

    return (
        <Tag className={containerClassName} title={props.title} onClick={props.onClick} {...anchorProps}>
            {props.img && (
                <span className={imgContainerClassName}>
                    <PromoIllustration img={props.img} loadingLazy={props.loadingLazy} />
                </span>
            )}
            {props.title && (
                <div className={styles.title}>
                    <PromoText color={'baseColor'} tag="div" variant={'subheader'}>
                        {props.title}
                    </PromoText>
                </div>
            )}
            {props.subtitle && (
                <div className={styles.subtitle}>
                    <PromoDangerouslyHtml color={'gray40'} dangerouslyHtml={props.subtitle} tag={'div'} />
                </div>
            )}
            {props.linkText && (
                <div className={styles.learnMoreButton}>
                    <PromoButton variant="tertiary" type="pseudo" caption={props.linkText} />
                </div>
            )}
        </Tag>
    );
};

ListingTile.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    img: PropTypes.array,
    onClick: PropTypes.func,
    loadingLazy: PropTypes.bool,
};
